<div class="tracking-page-main-container">
  <ng-template pdqHeaderContent>
    <div class="tracking-page-main-container__header">
      <pdq-button
        (onClick)="onSave()"
        variant="primary"
        [disabled]="formGroup?.invalid || isSaving || !formGroup.dirty"
        [loading]="isSaving"
        >Save</pdq-button
      >
    </div>
  </ng-template>
  <div class="tracking-page-main-container__header__text">
    <p>Data for the past 90 days</p>
  </div>
  <tracking-page-metrics
    [trackingPageMetrics]="trackingPageMetrics$ | async"
    [isTrackingPageLoading]="isTrackingPageLoading$ | async"
    [shop]="shop"></tracking-page-metrics>

  @if (isLoading) {
    <app-main-loader-lottie> </app-main-loader-lottie>
  } @else {
    @if (shopRequirements?.updateRequired) {
      <div style="padding: 0 0 32px 0">
        <pdq-banner
          variant="attention"
          [closable]="false"
          bannerTitle="Update required to create coupons"
          content="You've selected the Coupon Offer Type, but your current app permissions do not include the ability to
              create coupons. Please update your app to enable the new permissions and to access this feature."
          button="Update app"
          variantButton="ghost"
          (onButtonClick)="onUpdateAppPermissions()">
        </pdq-banner>
      </div>
    }
    <tracking-page-configuration
      [formGroup]="formGroup"
      [trackingPageConfiguration]="trackingPageConfiguration"
      [shop]="shop"></tracking-page-configuration>
  }
</div>
